export default __webpack_public_path__ + "static/media/ovalsMulti.818d1a68.png";